module.exports = __webpack_public_path__ + "img/pr-1.57dcfb72.png";